import dynamic from 'next/dynamic';
import { Props } from './ScrollToTopButton';

export const DynamicScrollToTopButton = dynamic<Props>(
    () =>
        import('./ScrollToTopButton').then(
            // biome-ignore lint/suspicious/noExplicitAny: legacy
            md => md.ScrollToTopButton as any /* please TS */,
        ),
    {
        ssr: false,
    },
);
